import { colors, fonts } from '../theme';
import { dmpSteps } from './dmpSteps';

const DigitalMaterialPassport = () => (
  <section style={{ padding: 'clamp(56px, 8vw, 96px) clamp(20px, 5vw, 48px)', background: colors.bg }}>
    <div style={{ maxWidth: 1080, margin: '0 auto' }}>
      <div style={{ maxWidth: 760, marginBottom: 48 }}>
        <p style={{ color: colors.teal, fontSize: 12.5, fontFamily: fonts.mono, letterSpacing: '0.14em', textTransform: 'uppercase', fontWeight: 600, marginBottom: 16 }}>Digital Material Passport</p>
        <h2 style={{ fontSize: 'clamp(26px,3.4vw,38px)', fontFamily: fonts.display, lineHeight: 1.3, color: colors.navy, marginBottom: 14 }}>
          From requirement to proof, in four steps
        </h2>
        <p style={{ color: colors.slateDark, fontSize: 16.5, lineHeight: 1.65, maxWidth: 640 }}>
          The execution layer turns your existing systems — ERP, MES, QMS, LIMS — into a continuous, auditable chain of evidence, without asking your team to change how they work.
        </p>
      </div>

      <div>
        {dmpSteps.map((step, i) => (
          <div key={step.num} style={{
            display: 'grid', gridTemplateColumns: '64px 1fr', gap: 28,
            padding: '34px 0',
            borderTop: `1px solid ${colors.border}`,
            borderBottom: i === dmpSteps.length - 1 ? `1px solid ${colors.border}` : 'none',
          }}>
            <div style={{ fontFamily: fonts.mono, fontSize: 14, color: colors.teal, fontWeight: 600, paddingTop: 4 }}>{step.num}</div>
            <div>
              <h3 style={{ fontSize: 21, fontFamily: fonts.display, color: colors.navy, marginBottom: 8 }}>
                {step.title}
                {step.optional && (
                  <span style={{ marginLeft: 10, fontFamily: fonts.mono, fontSize: 10.5, color: colors.slate, border: `1px solid ${colors.border}`, borderRadius: 20, padding: '3px 10px', fontWeight: 600, verticalAlign: 'middle' }}>OPTIONAL</span>
                )}
              </h3>
              <p style={{ color: colors.slateDark, fontSize: 15, maxWidth: 640, lineHeight: 1.65 }}>{step.body}</p>
              <span style={{ fontFamily: fonts.mono, fontSize: 11, color: colors.teal, textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 12, display: 'inline-block', border: '1px solid rgba(0,201,167,0.35)', padding: '4px 10px', borderRadius: 20 }}>{step.tag}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default DigitalMaterialPassport;
